export const CUTOFF_DAY = 14 //請求締め日 14日
export const TRADE_DAY = 4 //約定日（引落日）4日

export const NORMAL_YEAR_DAYS = 365
export const LEAP_YEAR_DAYS = 366
